module.exports = __webpack_public_path__ + "1de6a6cba12de382e9bed2ada64626e5.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/animals/bear.svg
// module id = 78
// module chunks = 0